export function searchByFields<T>(data: T[] | null, searchText: string, fields: string[]): T[] {
    if (data?.length && fields.length && searchText.length) {
        searchText = searchText.toLowerCase();
        return data.filter((x) =>
            fields?.some((field) => {
                // Check if field is an array to include in search
                if (field.includes('[].')) {
                    const [array, arrayField] = field.split('[].');
                    return x[array].some((y) => {
                        return y[arrayField] && y[arrayField].toString().toLowerCase().match(searchText);
                    });
                }

                return x[field] && x[field].toString().toLowerCase().match(searchText);
            })
        );
    }
    return data ?? [];
}
